import styled from 'styled-components'
import { belowTablet } from 'utilities/styled'
import FilterBase from 'components/filter'

export const Filter = styled(FilterBase)`
    ${belowTablet`
        margin-bottom: 16px;
    `}
`